<div class="header-title">
    <div class="flex u-align-items-center u-pa-20">
        <div class="flex flex-align-center">
            <a routerLink="/button" aria-label="back"
                class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
                <span class="u-icon icon-chevron-left"></span>
                <span class="u-btn-text">Back</span>
            </a>
        </div>
        <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
            <h1 class="font-semibold u-ma-0 flex header-title--name">Page list</h1>
        </div>
    </div>
    <div class="c-header__gradient"></div>
</div>

<div class="content">
    <h2>Page-list design use cases</h2>
    <div class="page-list-design-example">
      <maced-page-list *ngFor="let useCase of pageListUseCases; let caseIndex = index"
          [pagelistItems]="useCase" id="DesignPagelist{{caseIndex}}" [showHorizontalPagelist]="false">
        <ng-template let-pagelistItem #itemImage>
            <div class="c-page-list__item-image"
                [ngClass]="['c-page-list__item-image--' + (pagelistItem.imagePosition || 'left'), pagelistItem.imageStyleClass]">
                <img *ngIf="pagelistItem.imageUrl" [src]="pagelistItem.imageUrl" [alt]="pagelistItem.imageAlt || ''" />
                <em *ngIf="!pagelistItem.imageUrl && pagelistItem.imageClass" class="u-icon"
                    [ngClass]="pagelistItem.imageClass" [attr.role]="pagelistItem.imageAlt ? 'img' : null"
                    [attr.aria-label]="pagelistItem.imageAlt || null"
                    [attr.aria-hidden]="pagelistItem.imageAlt ? null : true"></em>
                <span *ngIf="!pagelistItem.imageUrl && !pagelistItem.imageClass && pagelistItem.imageText"
                    [attr.aria-label]="pagelistItem.imageAlt || null"
                    [attr.aria-hidden]="pagelistItem.imageAlt ? null : true">{{pagelistItem.imageText}}</span>
            </div>
        </ng-template>
        <ng-template let-pagelistItems let-inx="inx" #header>
            <maced-dropdown *ngIf="pagelistItems.hasDropdown" dropdownId="designDropdown{{caseIndex}}-{{inx}}"
                name="designDropdown{{caseIndex}}" ariaLabel="More actions" cheveronClass="icon-dots-vertical"
                [options]="pagelistItems.dropdownData" dropdownText="More actions">
            </maced-dropdown>
        </ng-template>
      </maced-page-list>
    </div>

    <h2>Existing page list</h2>
    <maced-page-list [pagelistItems]="pagelistItems" [id]="pagelistId" [showHorizontalPagelist]="showVeritcal">
        <ng-template let-pagelistItems let-inx = 'inx' #header>
            <maced-dropdown *ngIf="pagelistItems.hasDropdown" dropdownId="dropdownId{{inx}}" name="dropdownId4"
                ariaLabel="Dropdown list navigate with tab" cheveronClass="icon-dots-horizontal"
                [options]="pagelistItems.dropdownData" dropdownText="Dropdown">
            </maced-dropdown>
        </ng-template>
    </maced-page-list>
</div>
